export default __webpack_public_path__ + "static/media/pos-dashboard-2.5fcb2d67.jpg";